export const isPasswordResetRequired = (flag) =>
  flag === true ||
  flag === 1 ||
  (typeof flag === 'string' &&
    ['y', 'yes', 'true', '1'].includes(flag.trim().toLowerCase()));
